import { memo } from 'react'
import { CloudSun, CalendarDays, Map, MapPin } from 'lucide-react'
import { navigate } from '../../../app/router'
import { openPlaces, openMap, openForecast } from '../../shell/actions'
import { useUi } from '../../../app/ui'
import './navigation.css'

export const PhoneNavigation = memo(function PhoneNavigation({ path }: { path: string }) {
  const places = useUi((state) => state.phoneList)
  const forecast = ['/', '/forecast', '/hours', '/conditions', '/models', '/alerts'].includes(path)
  return <nav className="v5-phone-navigation" data-zone="phone-navigation" data-qa="phone-navigation" aria-label="Weather sections">
    <button aria-current={!places && forecast ? 'page' : undefined} data-nav-key="phone-forecast" onClick={openForecast}><CloudSun size={21} aria-hidden="true" /><span>Forecast</span></button>
    <button aria-current={!places && path === '/days' ? 'page' : undefined} data-nav-key="phone-days" onClick={() => navigate('/days')}><CalendarDays size={21} aria-hidden="true" /><span>Days</span></button>
    <button aria-current={!places && (path === '/map' || path === '/radar') ? 'page' : undefined} data-nav-key="phone-radar" onClick={openMap}><Map size={21} aria-hidden="true" /><span>Radar</span></button>
    <button aria-current={places || path === '/places' ? 'page' : undefined} aria-haspopup="dialog" aria-expanded={places} onClick={openPlaces}><MapPin size={21} aria-hidden="true" /><span>Places</span></button>
  </nav>
})
